/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Box, CircularProgress } from '@mui/material';
import { useTranslation } from 'react-i18next';
import fileApi from '~/apis/file';

interface PreviewFileProps {
  open: boolean;
  file: any;
  onClose: () => void;
}

const ModalDownloadFile: React.FC<PreviewFileProps> = ({ open, file, onClose }) => {
  const { t } = useTranslation('admin/common');
  const [loading, setLoading] = useState(true);
  const renderContent = () => {
    const isPDF = file?.name?.toLowerCase().endsWith('.pdf');

    if (file?.type === 'IMAGE') {
      return (
        <img
          src={file?.url}
          alt={file?.name}
          onLoad={() => setLoading(false)}
          style={{
            maxWidth: '100%',
            maxHeight: '70vh',
            objectFit: 'contain',
            margin: '0 auto',
            display: 'block',
          }}
        />
      );
    }

    if (isPDF) {
      return (
        <>
          {loading && (
            <Box sx={{ textAlign: 'center', mb: 2 }}>
              <CircularProgress />
            </Box>
          )}
          <iframe
            src={file?.url}
            onLoad={() => setLoading(false)}
            style={{
              width: '100%',
              height: '70vh',
              border: 'none',
              opacity: loading ? 0 : 1,
              transition: 'opacity 0.3s ease-in-out',
            }}
          />
        </>
      );
    }

    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '70vh',
          fontSize: '1.2rem',
          color: 'gray',
        }}
      >
        {file?.name}
      </Box>
    );
  };

  const handleDownload = async (id: string) => {
    const result = await fileApi.downloadFileUrl(id);
    const fileUrl = result?.data?.data?.fileUrl;
    if (result?.data?.data?.fileUrl) {
      const anchor = document.createElement('a');
      anchor.href = String(fileUrl);
      anchor.download = file?.name;
      anchor.click();
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xl' fullWidth>
      <DialogTitle>{file?.name}</DialogTitle>
      <DialogContent dividers>{renderContent()}</DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button variant='contained' color='primary' onClick={() => handleDownload(file?.id)}>
          {t('download')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalDownloadFile;
